<template>
  <div>
    <nav-bar class="home-nav">
      <div slot="left" @click="onClickLeft">返回</div>
      <div slot="center">校园体育活动</div>
    </nav-bar>

    <van-sticky>
      <van-cell title="添加校园体育活动" size="large" is-link to="AddCampusActivities"/>
      <van-dropdown-menu>
        <van-dropdown-item v-model="type" :options="types" @change="typeChange"/>
      </van-dropdown-menu>
    </van-sticky>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        loading-text="努力加载中"
      >
        <van-swipe-cell v-for="item in campusActivitiesList" :key="item.id">
          <template slot="left">
            <van-button square type="info" @click="download(item.id,item.title,item.team)"
                        text="下载"/>
          </template>
          <van-cell :border="false" :label="(item.team?'最大队伍:':'最大人数:')+item.maxp"
                    :title="item.title" value="<<滑动<<"/>
          <template slot="right">
            <van-button square type="danger" @click="delCA(item.id)" text="删除"/>
            <van-button square type="info" @click="lookCAMember(item.id,item.team,item.title)" text="人员"/>
            <van-button square type="primary" @click="lookCA(item.id)" text="详情"/>
          </template>
        </van-swipe-cell>

      </van-list>
    </van-pull-refresh>

    <van-action-sheet v-model="descriptionShow" :title="this.info.title+' '+this.countp+'人'">
      <van-cell v-if="type"
                title="单个队伍限制" :value="this.info.minSize+'-'+this.info.maxSize+'人'"/>
      <div style="  padding: 16px 16px 70px;font-size: 18px;font-family: 楷体;">{{ this.info.des }}</div>

      <div style="padding-top: 50px"></div>
    </van-action-sheet>
  </div>
</template>

<script>
import NavBar from "components/common/navbar/NavBar";
import {
  DelAllCourse,
  GetCourseScoreDownLoad

} from "../../network/course";
import {
  GetCampusActivitiesList,
  GetCampusActivitiesInfoById,
  DelCampusActivitiesById
} from "../../network/campus_activities"
import Vue from 'vue';
import {
  Tab,
  Tabs,
  Field,
  Popup,
  Cell,
  Button,
  PullRefresh,
  List,
  SwipeCell,
  Toast, Dialog,
  Sticky,
  ActionSheet,
  NoticeBar,
  Row,
  Col,
  DropdownItem,
  DropdownMenu
} from 'vant';


Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Cell);
Vue.use(Button);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(SwipeCell);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Sticky);
Vue.use(ActionSheet);
Vue.use(NoticeBar);
Vue.use(Row);
Vue.use(Col);
Vue.use(DropdownItem);
Vue.use(DropdownMenu);

export default {
  name: "CampusActivities",
  components: {
    NavBar
  },
  data() {
    return {
      campusActivitiesList: [],
      // dropdown item
      type: false,
      types: [
        {text: '个人活动', value: false},
        {text: '团体活动', value: true},
      ],
      //refresh
      refreshing: false,
      loading: false,
      finished: true,

      //ActionSheet
      descriptionShow: false,
      info: {},
      countp: 0,
    };
  },
  activated() {
    this.getCampusActivitiesLists();
  },

  methods: {
    //refresh
    onLoad() {
      setTimeout(() => {
        this.refreshing = false;
        Toast('刷新成功');
      }, 1500);
    },
    typeChange() {
      this.getCampusActivitiesLists();
    },
    onRefresh() {
      // 清空列表数据;
      this.campusActivitiesList = [];
      // 将 loading 设置为 true，表示处于加载状态
      //this.loading = true;
      this.onLoad();
      setTimeout(() => {
        // 重新加载数据
        this.getCampusActivitiesLists();
        this.isLoading = false;
      }, 1000);
    },
    getCampusActivitiesLists() {
      GetCampusActivitiesList(this.type).then(res => {
        this.campusActivitiesList = [];
        this.campusActivitiesList.push(...res);
      });
    },
    delCA(id) {
      Dialog.confirm({
        title: '提示',
        message: '确定要删除吗'
      }).then(() => {
        DelCampusActivitiesById(id).then(res => {
            if (res) {
              this.campusActivitiesList = this.campusActivitiesList.filter(item => item.id != id);
              Toast.success('刪除成功');
            } else {
              Toast.fail('删除失败');
            }
          }
        ).catch(res => {
          Toast.fail('删除失败');
        })
        // on confirm
      }).catch(() => {
        // on cancel
      });
    },
    lookCA(id) {
      GetCampusActivitiesInfoById(id).then(res => {
        if (res.status) {
          this.descriptionShow = true;
          this.info = res.info;
          this.countp = res.count;
        }
      })
    },
    lookCAMember(id, team, title) {
      this.$router.replace({path: '/CampusActivitiesMember', query: {cid: id, team: team, title: title}})
    },
    onClickLeft() {
      this.$router.replace("/more");
    },

    download(cid, title, team) {
      Dialog.confirm({
        title: '提示',
        message: '确定要下载' + title + '吗'
      }).then(() => {
        var a = document.createElement('a');
        a.target = "_blank";
        let hostname = document.location.hostname;
        if (hostname.indexOf("sports.hhstu.club") != -1) {
          a.href = 'http://' + hostname + "/api/download/CampusActivitiesDownLoad?cid=" + cid + '&title=' + title + '&team=' + team;
        } else {
          a.href = 'http://' + hostname + ":8080/api/download/CampusActivitiesDownLoad?cid=" + cid + '&title=' + title + '&team=' + team;
        }
        a.click();
        // on confirm
      }).catch(() => {
        // on cancel
      });
    }
  }
}
</script>

<style scoped>
.home-nav {
  background-color: var(--color-tint);
  color: #fff;
}

.test {
  width: 70%;
  display: flex;

  position: fixed;

  right: 0;

}
</style>
